export function generateEsarVhpId({ clientCode, sequence }: { sequence: number; clientCode?: string }): string {
    const numberPadding = (num: number, places: number) => String(num).padStart(places, '0');
    const seqWithPadding = numberPadding(sequence, 8);
    const seqArray = seqWithPadding.split('');
    const sum = seqArray.reduce<number>((previousValue, currentValue) => {
        return previousValue + parseInt(currentValue);
    }, 0);
    const lastValue = seqArray[seqArray.length - 1] !== '0' ? parseInt(seqArray[seqArray.length - 1]) : 10;
    const checkSum = sum % lastValue;

    return `${clientCode ? clientCode : ''}${seqWithPadding}${checkSum}`;
}
